/**
 * MiniCart Component
 */
 (function () {
    'use strict';

    /**
     * This component manages the side mini cart in the header
     * @name miniCartCtrl
     * @type ItxMiniCartCmpCtrl
     */
    var ItxMiniCartCmp = {
        controller: ItxMiniCartCmpCtrl,
        templateUrl: 'mini-cart.component.html'
    };

    angular.module('itxApp.common').component('itxMiniCart', ItxMiniCartCmp);

    ItxMiniCartCmpCtrl.$inject = [
        '$rootScope',
        '$scope',
        'SaveForLaterService',
        'NavigationService',
        'ItxHeaderFct',
        'ItxShopCartFct',
        'ItxConfigurationSvc',
        'ItxTranslateSvc',
        'imCartService',
        'preCommonCmsConfigSvc',
        'ItxLoaderFct',
        'ItxLoginSvc',
        'UserService'
    ];

    function ItxMiniCartCmpCtrl(
        $rootScope,
        $scope,
        SaveForLaterService,
        NavigationService,
        ItxHeaderFct,
        ItxShopCartFct,
        ItxConfigurationSvc,
        ItxTranslateSvc,
        imCartService,
        preCommonCmsConfigSvc,
        ItxLoaderFct,
        ItxLoginSvc,
        UserService
    ) {
        var _this = this;

        var itemsToShowDefault = 3;

        _this.ItxHeaderFct = ItxHeaderFct;
        _this.itemsToShow = itemsToShowDefault;
        _this.loadedCmp = false;
        _this.formatPrice = inditex.formatPrice.bind(inditex);
        var price = 0;
        _this.freeShippingOver = 0;

        _this.wishEnabled = false;

        _this._buylaterTitleMobile = 'legacy.saveForLater.title.mobile';

        _this.actionsAllowed = {
            events: {
                updateQuantity: 'update:quantity',
                updateSize: 'update:size',
                deleteToCart: 'delete:shopcart',
                addBuylater: 'add:buylater'
            },
            translations: {
                delete: ItxTranslateSvc.translateCms('legacy.common.delete'),
                addToCart: ItxTranslateSvc.translateCms('legacy.common.addToCart'),
                buylater: ItxTranslateSvc.translateCms('legacy.saveForLater.button')
            }
        };

        _this.itemTypeShopcart = {
            name: 'item-mini-cart',
            actions: []
        };

        _this.shopcartCount = 0;

        _this.$onInit = function () {
            _this.freShippingValue = ItxConfigurationSvc.get('freeShippingOver');
            syncCart(inditex.iUserJSON.shopCart);
            //ItxShopCartFct.getCart();
            //_this.getWishlist();
        };

        $rootScope.$on('itx-shop-cart:updated', function (e, args) {
            syncCart(args);
        });

        _this.getWishlist = function () {
            SaveForLaterService.isActive().then(function (buylater) {
                _this.buylater = buylater;

                if (buylater.enabled) {
                    _this.exitsApolloWishlist();
                    SaveForLaterService.getList().then(function (buylater) {
                        _this.buylater = buylater;
                    });

                    $rootScope.$on(buylater.event, function (e, buylater) {
                        if (buylater) {
                            _this.buylater = buylater;
                        } else {
                            _this.updateWishlistCount();
                        }
                    });
                } else {
                    $('#page').addClass('view-tab-cart');
                    $('#page').addClass('buylater-disabled');
                }
            });
        };

        _this.updateWishlistCount = function () {
            if (_this.wishEnabled) {
                SaveForLaterService.getList().then(function (buylater) {
                    _this.buylater = buylater;
                });
            }
        };

        _this.exitsApolloWishlist = function () {
            preCommonCmsConfigSvc
                .getProperty('enable_wishlist')
                .then(function (wishEnabled) {
                    if (wishEnabled) {
                        _this.wishEnabled = true;
                        _this._buylaterTitle = 'dev.cart.wishlist';
                        _this._buylaterTitleMobile = 'dev.cart.wishlist';
                        _this.itemTypeShopcart.name = 'item-mini-cart-wishlist';
                        _this.itemTypeShopcart.actions.push(
                            {
                                name: _this.actionsAllowed.events.addBuylater,
                                text: ItxTranslateSvc.translateCms('dev.cart.addToWishlist')
                            },
                            {
                                name: _this.actionsAllowed.events.deleteToCart,
                                text: _this.actionsAllowed.translations.delete
                            }
                        );
                    }
                })
                .catch(function (err) {
                    console.error('Error getting CMS key: enable_wishlist ');
                });
        };

        $scope.$on('itx-shop-cart:updated', function (e, args) {
            syncCart(args);
            // _this.isAuthenticated = UserService.isAuthenticated();
            // _this.updateWishlistCount();
        });

        $rootScope.$on('buylater:update', function (e, args) {
            _this.updateWishlistCount();
        });

        _this.goToShopCart = function () {
            NavigationService.goToShopCartPage();
        };

        _this.showAll = function () {
            itemsToShowDefault = _this.shopCart.items.length;
            _this.itemsToShow = _this.shopCart.items.length;
        };

        _this.showMiniwishlist = function () {
            if (_this.wishEnabled) {
                const options = {
                    bubbles: true,
                    composed: true,
                    detail: {
                        extra: {
                            typeEvent: 'mini-wish'
                        }
                    }
                };
                document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
            }
        };

        // _this.getTotalFreeShipping = function () {
        //     return ItxTranslateSvc.translate('ItxShopCartView.cesta.freeShipping', inditex.formatPrice(parseInt(_this.freShippingValue) - _this.shopCart.totalProduct));
        // };

        _this.getMoreMessage = function () {
            const cntItemsHidden = _this.shopCart.items.length - _this.itemsToShow;
            const key = cntItemsHidden > 1 ? 'dev.shopCart.moreProducts' : 'dev.shopCart.moreProduct';
            const translate = ItxTranslateSvc.translateCms(key);
            return translate.replace('{{ $0 }}', cntItemsHidden).replace(key, cntItemsHidden);
        };

        function syncCart(shopCart) {
            _this.shopCart = shopCart;
            price = _this.shopCart.totalProduct;
            if (shopCart && shopCart.items) {
                _this.shopcartCount = shopCart.items.length;
            }
            _this.moreMessage = _this.getMoreMessage();
            _this.itemsToShow = itemsToShowDefault;
            if (!_this.loadedCmp) {
                _this.loadedCmp = true;
            }

            _this.manageFreeShippingOver(_this.shopCart);

            if (price != _this.shopCart.state.totalProduct) {
                price = _this.shopCart.state.totalProduct;
            }

            _this.totalPriceCart = _this.formatPrice(price || 0);
        }

        _this.manageFreeShippingOver = function (shopCart) {
            _this.showFreeShippingOver = false;
            if (!ItxShopCartFct.hasVirtualCard()) {
                ItxShopCartFct.getFreeShippingOver(shopCart).then(function (freeShipping) {
                    _this.freeShippingOver = freeShipping.value;
                    _this.showFreeShippingOver = freeShipping.show;
                });
            }
        };

        _this.onAction = function (action, item, value) {
            switch (action) {
                case _this.actionsAllowed.events.deleteToCart:
                    _this.deleteItems([{ id: item.id, quantity: 0 }]);
                    imCartService.itemQuantityChange(item, 0);
                    break;
                case _this.actionsAllowed.events.updateQuantity:
                    _this.updateQuantity(item, value);
                    imCartService.itemQuantityChange(item, value);
                    break;
                case _this.actionsAllowed.events.updateSize:
                    _this.updateSize(item, value);
                    imCartService.itemSizeChange(item, value);
                    break;
                case _this.actionsAllowed.events.addBuylater:
                    if (_this.isAuthenticated) {
                        _this.addToWishlist(item, _this.wishEnabled);
                        imCartService.saveForLater(item);
                    } else {
                        ItxLoginSvc.popupSignIn().then(function (res) {
                            if (res.isAuthenticated) {
                                SaveForLaterService.addItemList(item, _this.wishEnabled);
                                imCartService.saveForLater(item);
                            }
                        });
                    }
                    break;
            }
        };

        _this.updateQuantity = function (item, quantity) {
            _this.loadedCmp = false;
            ItxShopCartFct.updateCart([{ id: item.id, quantity: quantity }])
                .then(function () {})
                .finally(function () {
                    _this.loadedCmp = true;
                });
        };

        _this.updateSize = function (item, value) {
            _this.loadedCmp = false;
            ItxShopCartFct.changeSize(item, value)
                .then(function () {})
                .finally(function () {
                    _this.loadedCmp = true;
                });
        };

        _this.deleteItems = function (items) {
            _this.loadedCmp = false;
            ItxShopCartFct.updateCart(items).finally(function () {
                _this.updateShopCartCounter();
                _this.loadedCmp = true;
            });
        };

        _this.addToWishlist = function (item, wishEnabled) {
            _this.loadedCmp = false;
            SaveForLaterService.addItemList(item, wishEnabled);
        };

        _this.updateShopCartCounter = function () {
            const options = {
                bubbles: true,
                composed: true,
                detail: {
                    extra: {
                        typeEvent: 'update-shop-cart'
                    }
                }
            };
            document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
        };
    }
})();
